import { render } from "./MTokenCartItemDelete.vue?vue&type=template&id=579d9670&scoped=true&ts=true"
import script from "./MTokenCartItemDelete.vue?vue&type=script&lang=ts"
export * from "./MTokenCartItemDelete.vue?vue&type=script&lang=ts"

import "./MTokenCartItemDelete.vue?vue&type=style&index=0&id=579d9670&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579d9670"]])

export default __exports__